"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Period = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const Datepicker_svg_1 = __importDefault(require("@veeam/uikit-assets/src/icons/common/Datepicker/Datepicker.svg"));
const core_1 = require("@veeam/core");
const core_2 = require("../../../../core");
const PeriodModel_1 = require("./PeriodModel");
require("./types");
const Period = ({ model }) => {
    const { t } = core_2.useFeatureContext();
    const comboboxModel = core_1.useModelBuilder([
        { id: PeriodModel_1.PERIOD.day, name: t('dashboard|period|last24Hours') },
        { id: PeriodModel_1.PERIOD.week, name: t('dashboard|period|last7Days') },
        { id: PeriodModel_1.PERIOD.month, name: t('dashboard|period|lastMonth') },
        { id: PeriodModel_1.PERIOD.year, name: t('dashboard|period|lastYear') },
    ]);
    const form = core_1.useForm(model);
    return (react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.row, align: components_1.STACK_ALIGN.center },
        react_1.default.createElement(components_1.Icon, { src: Datepicker_svg_1.default }),
        react_1.default.createElement(components_1.ComboboxField, { field: form.fields.id, model: comboboxModel, widthSize: null, controlRenderer: components_1.createLinkControl() })));
};
exports.Period = Period;
//# sourceMappingURL=Period.js.map